/**
 *
 * @component 个人中心/我的方案/项目管理——创建项目、项目续费
 *
 **/

import React, { useReducer } from 'react';
import { inject, observer } from 'mobx-react';
import { LoadingOutlined } from '@ant-design/icons';
import {
    Input,
    Select,
    Image,
    Form,
    Button,
    Spin,
    Row,
    Col,
    AutoComplete,
    message,
} from 'antd';
import PinyinMatch from 'pinyin-match';
import { getAreas, queryEstate } from '@/api/common1.4';
import { effectProduct, payProduct } from '@/api/personCenter/projectSpace1.4';
import { createFreeProduct } from '&/api/personCenter/projectSpace';
import BaseModal from '&/components/BaseModal';
import useWebSocket from '&/utils/customHooks/useWebSocket';
import QRCode from 'qrcode';
import useCalcAmount from '@/utils/customHooks/useCalcAmount1.4';
import { useRouteMatch, useHistory } from 'react-router-dom';
import './BuyService.scss';

const FREE_COUNT = 5; // 免费项目数量

function BuyService(props) {
    const {
        visible,
        setVisible,
        appStore,
        initState = 'form',
        initData = {},
        div = 1, // 项目类型，1：智能设计项目，2：施工协作项目
        type = 1, //  1  创建  2编辑
        onSubmit, // 提交form回调
        genreList = [], //  风格选项列表
        refesh,
        role,
        houseType,
        gratisProjectNum = '5',
    } = props;

    const TITLES = {
        form: type === 1 ? intl.get('projectSpace.creatProject') : '编辑项目', //  表单提交
        unpaid: intl.get('userCenter.unpaid'), // 重新支付
        pay: intl.get('projectSpace.scanPay'), // 扫码支付
        paid: intl.get('userCenter.paySuccess'), // 支付成功
    };

    const [currentState, dispatch] = React.useReducer(
        (_, action) => {
            if (action.type === '') {
                return {
                    title: '',
                    step: '',
                };
            }
            return {
                title: TITLES[action.type],
                step: action.type,
            };
        },
        {
            title: '',
            step: '',
        }
    );

    const [loading, setLoading] = useState({
        code: false,
        form: false,
    });

    const [formRef] = Form.useForm();

    const [periodChange, paymentAmount, expireDate, period] = useCalcAmount(
        initData.expireDateMax
    );

    //  匹配详情页面
    const match = useRouteMatch({
        path: '/user-center/project-space/project-detail',
        strict: false, // 全路径?
        sensitive: false, // 大小写?
    });

    const timeInterval = useRef();
    const [timeCount, setTimeCount] = useState(5);
    useEffect(() => {
        // initData.createWithInit  // 标识不是编辑项目，但有预设值
        switch (currentState.step) {
            case 'form':
                periodChange(+gratisProjectNum < FREE_COUNT ? 6 : 1);
                initData.id || initData.createWithInit
                    ? initForm()
                    : setAreaSelected(Array(3));
                queryAreas();
                break;
            case 'unpaid':
                periodChange(initData.payCode?.period || 1);
                break;

            case 'pay':
                break;
            case 'paid':
                // 支付成功五秒自动跳转详情
                setTimeCount(5);
                if (!match) {
                    timeInterval.current = setInterval(() => {
                        console.log(timeCount, 'timeCount');
                        setTimeCount(prev => {
                            if (prev === 0) {
                                stopTarget();
                                targetDetail();
                                return prev;
                            }
                            return --prev;
                        });
                    }, 1_000);
                }
                break;
            default:
                break;
        }
    }, [currentState.step]);

    function stopTarget() {
        timeInterval.current && clearInterval(timeInterval.current);
        timeInterval.current = null;
    }

    const stopQueryEstate = useRef(false);

    useEffect(() => {
        if (!visible) {
            stopTarget();
            closeSocket();
            viewInitArea.current = -1;
            stopQueryEstate.current = false;
            setAreaSelected(Array(3));
            return;
        }
        dispatch({ type: initState });
        return stopTarget;
    }, [visible]);

    const [createName, setCreateName] = useState(appStore.userInfo.username);
    const [regionOptions, setRegionOptions] = useState([[], [], []]); // 省市区数据
    const [areaSelected, setAreaSelected] = useState(Array(3)); // 省市区选中的code
    const [selectLoading, setSelectLoading] = useState([false, false, false]);
    const [estateList, setEstateList] = useState([]); // 查询到的小区列表
    const viewInitArea = useRef(-1); //   编辑的时候控制  行政区划回显
    const cacheId = useRef(); // 是否有值决定提交的时候提交districtId还是districtName

    function initForm() {
        setCreateName(initData.createName);
        let districtId = initData.districtName || null;
        cacheId.current = initData.districtId;

        // 适配新的户型数据
        if (initData.houseType?.length === 3) {
            initData.houseType.push(0);
        }

        const PARAMS = {
            projectName: initData.name,
            note: initData.note,
            districtId,
            houseType: initData.houseType.map(e => +e),
            design: initData.design,
            area: initData.area,
            genre: initData.genre,
            period: initData.payCode?.period || 1,
        };
        setwatchFildes(prev => {
            const NEXT = [...prev];
            NEXT[2] = !!initData.name;
            NEXT[1] = !!districtId;
            return NEXT;
        });

        formRef.setFieldsValue(PARAMS);
        viewInitArea.current = 0;
    }

    // 关闭modal 初始化form数据
    const closeModal = () => {
        //  在详情页  刷新详情
        if (['pay', 'paid'].includes(currentState.step) && match) {
            onSubmit?.();
        }
        //   支付中且不在详情页  关闭后跳转详情页
        if (['pay'].includes(currentState.step) && !match) {
            targetDetail();
        }
        //   支付成功且不在详情页   停止跳转
        if (['paid'].includes(currentState.step) && !match) {
            stopTarget();
            refesh && refesh();
        }
        modalReset();
    };

    const modalReset = () => {
        formRef?.resetFields();
        dispatch({ type: '' });
        setVisible(false);
    };

    const catchParams = useRef({});
    const history = useHistory();

    // 跳转项目详情
    function targetDetail() {
        const pathanme = history?.location?.pathname;
        if (
            pathanme === '/user-center/project-space/project-detail' ||
            pathanme === '/user-center/project-space/scheme-detail'
        ) {
            refesh && refesh();
            modalReset();
            return;
        }
        history.push({
            pathname: `/user-center/project-space/${
                ['project-detail', 'scheme-detail'][div - 1] //  设计/协同  详情
            }`,
            search: `?id=${catchParams.current.projectId}`,
            state: {
                projectStatus: currentState.step === 'paid' ? '1' : null,
            },
        });
    }

    const [connectSocket, closeSocket] = useWebSocket(
        { userId: appStore.userInfo.userId },
        () => {
            dispatch({ type: 'paid' });
        }
    );

    //  提交编辑或新建
    async function onVerification(values) {
        let params = { ...values };
        if (initData.id && !initData.createWithInit) {
            params = Object.assign(params, {
                projectId: initData.id,
                type,
                houseType: values.houseType.filter(e => !!e || e === 0),
            });
        }

        if (initData.schemeId) {
            params.schemeId = initData.schemeId;
        }

        if (
            cacheId.current ||
            (initData.createWithInit && initData.districtId)
        ) {
            params.districtId = cacheId.current;
        } else {
            params.districtName = values.districtId;
            params.districtId = null;
        }

        if (type === 1) {
            params.div = div;
        }
        [params.province, params.city, params.district] = areaSelected;
        setLoading({
            ...loading,
            form: true,
        });

        try {
            if (+gratisProjectNum < FREE_COUNT) {
                params.isProd = 2;
                if (params.districtId) {
                    params.districtName = estateList.find(
                        e => e.id === params.districtId
                    )?.value;
                }
                const { data, msg } = await createFreeProduct(params);
                if (+data.status === 1) {
                    setLoading({
                        ...loading,
                        form: false,
                    });
                    modalReset();
                    catchParams.current.projectId = data.projectId;
                    dispatch({ type: 'paid' });
                    targetDetail();
                    return;
                } else {
                    message.warning(msg);
                }
            }
            const { data } = await effectProduct(params);
            onSubmit?.();
            if (type === 2) return closeModal();
            dispatch({ type: 'pay' });
            setLoading({
                ...loading,
                form: false,
            });
            generatePayQRCode(data.projectId, params.period, 1, data.payUrl);
        } finally {
            setLoading({
                ...loading,
                form: false,
            });
        }
    }

    // 去除options中额外给value添加的中括号
    const delSquareBrackets = str => str.replace(/\[.*?\]/g, '');

    const [payData, setPayData] = useState({});

    //  生成支付二维码  period 创建必传
    async function generatePayQRCode(projectId, period, initType, payUrl) {
        let promise = Promise.resolve({ data: { payUrl } });
        // payType = 1, //1：待支付，2：续费，3重新下单
        let payType = initType;
        if (!payType) {
            switch (initData.status) {
                case '3':
                    payType = 1; // 待支付
                    break;
                case '4':
                    payType = 3; // 重新下单
                    break;
                case '5':
                    payType = 2; // 续费
                    break;
                default:
                    break;
            }
        }
        catchParams.current = {
            projectId,
            period,
            type: payType,
            amount: paymentAmount,
        };
        setLoading(prev => {
            return { ...prev, code: true };
        });
        if (!payUrl) {
            promise = payProduct(catchParams.current);
        }
        promise
            .then(({ data }) => {
                QRCode.toDataURL(
                    data.payUrl,
                    { margin: 0 },
                    function (err, url) {
                        if (err) throw err;
                        data.payUrl = url;
                        setPayData({
                            amount: paymentAmount,
                            ...data,
                        });
                        connectSocket();
                    }
                );
            })
            .finally(() => {
                setLoading(prev => {
                    return { ...prev, code: false };
                });
            });
    }

    //  待支付状态下去支付
    function toPay() {
        dispatch({ type: 'pay' });
        generatePayQRCode(initData.id, period);
    }

    const refreshCode = () => {
        generatePayQRCode(
            catchParams.current.projectId,
            catchParams.current.period,
            catchParams.current.type
        );
    };

    const [watchField, setwatchFildes] = useState([true, false, false]);

    //   监听form字段变化(period = 项目周期)
    function fieldsChangeHandler([e]) {
        let idx = -1;
        switch (e.name[0]) {
            case 'period':
                periodChange(e.value);
                idx = 0;
                break;
            case 'districtId':
                idx = 1;
                break;
            case 'projectName':
                idx = 2;
                break;
            default:
                break;
        }
        if (idx < 0) return;
        setwatchFildes(prev => {
            const NEXT = [...prev];
            NEXT[idx] = !!e.value;
            return NEXT;
        });
    }

    useEffect(() => {
        if (!areaSelected[0]) return;
        setRegionOptions(prev => {
            const next = [...prev];
            next[1] = [];
            next[2] = [];
            return next;
        });
        queryAreas(1, areaSelected[0]);
    }, [areaSelected[0]]);

    useEffect(() => {
        if (!areaSelected[1]) return;
        setRegionOptions(prev => {
            const next = [...prev];
            next[2] = [];
            return next;
        });
        queryAreas(2, areaSelected[1]);
    }, [areaSelected[1]]);

    useEffect(() => {
        getEstate();
    }, [areaSelected[2]]);

    useEffect(() => {
        // 新建项目的时候
        if (currentState.step === 'form' && type === 1) {
            autoSetRegion();
        }
    }, [currentState.step, type]);

    // 根据用户定位自动设置省市
    async function autoSetRegion() {
        if (initData.province && initData.city && initData.district) return;
        await houseType.queryGeo();
        const { currentGeo = [] } = houseType;
        if (!currentGeo.length) throw new Error();
        setRegion(currentGeo[0].code, 0);
        const [, city, disc] = currentGeo;
        city && setRegion(city.code, 1);
        disc && setRegion(disc.code, 2);
    }

    function filterOption(input, { searchdata }) {
        if (!searchdata) return false;
        return PinyinMatch.match(searchdata, input);
    }

    const onSearch = () => {
        cacheId.current = null;
    };

    const onSelect = (_, opt) => {
        stopQueryEstate.current = true;
        cacheId.current = opt.id; // 小区ID
        let idx = 0;
        for (const iterator of opt.region) {
            setRegion(iterator, idx++);
        }
    };

    const [didUpdate, forceUpdate] = useReducer(s => s + 1, 0);

    useEffect(() => {
        didUpdate > 0 && formRef.validateFields(['districtId']);
    }, [didUpdate]);

    const onBlur = forceUpdate;

    //  查询省市区

    function queryAreas(idx = 0, code) {
        setSelectLoading(prev => {
            const next = [...prev];
            next[idx] = true;
            return next;
        });
        const PARAMS = {};
        // 不传参就是省份
        if (code) {
            PARAMS.code = code;
        } else if (idx > 0) {
            // 上一级的code
            PARAMS.code = areaSelected[idx - 1];
        }

        getAreas(PARAMS)
            .then(({ data = [] }) => {
                setRegionOptions(prev => {
                    const next = [...prev];
                    next[idx] = data;
                    return next;
                });
                viewInitArea.current > -1 && echoRegion();
            })
            .finally(() => {
                setSelectLoading(prev => {
                    const next = [...prev];
                    next[idx] = false;
                    return next;
                });
            });
    }

    //  回显省市区
    function echoRegion() {
        const initCodes = [initData.province, initData.city, initData.district];
        initCodes[viewInitArea.current] &&
            setRegion(initCodes[viewInitArea.current], viewInitArea.current);
        viewInitArea.current++;
        viewInitArea.current === 2 && (stopQueryEstate.current = true);
        viewInitArea.current === 3 && (viewInitArea.current = -1);
    }

    // isClear 是否清空小区字段(初始化的时候不清空)
    function setRegion(val, i, isClear = false) {
        if (isClear) {
            setEstateList([]);
            formRef.setFieldsValue({ districtId: '' });
        }
        setAreaSelected(prev => {
            if (prev[i] === val) return prev;
            const next = [...prev];
            next[i] = val;
            if (i === 0) {
                next[1] = null;
                next[2] = null;
            }
            if (i === 1) {
                next[2] = null;
            }
            return next;
        });
    }

    const [estateLoading, setEstateLoading] = useState(false);

    //  根据地区code查询小区    选择区的时候会自动调用 或者通过搜索调用
    function getEstate(keyword) {
        const [provinceCode, cityCode, districtCode] = areaSelected;
        // 没选择区 且没关键字 或者 阻止查询
        if ((!districtCode && !keyword) || stopQueryEstate.current) {
            stopQueryEstate.current = false;
            return;
        }

        let level, code;
        if (districtCode) {
            code = districtCode;
            level = 2;
        } else if (cityCode) {
            code = cityCode;
            level = 1;
        } else if (provinceCode) {
            code = provinceCode;
            level = 0;
        }

        setEstateLoading(true);
        queryEstate({ code, keyword, level })
            .then(({ data = [] }) => {
                //  options的key和value都要保持唯一性
                setEstateList(
                    data.map((e, i) => ({
                        value: e.name + `[${e.id}--${i}]`,
                        label: (
                            <>
                                {e.name}
                                <div className="select-address">
                                    {e.address}
                                </div>
                            </>
                        ),
                        region: [e.province, e.city, e.district],
                        key: `${e.id}--${i}`,
                        id: e.id,
                        searchdata: e.name + e.address,
                    }))
                );
            })
            .finally(() => {
                setEstateLoading(false);
            });
    }

    const { Option } = Select;
    const { Item } = Form;
    const suffixIcon = <i className="icon-caret-down filled" />;

    const parseNumber = num => {
        if (!num) return num;
        num = num.replace(/[^0-9]/g, '');
        if (num > 100) return 100;
        if (num < 1) return 1;
        return num;
    };

    const parseArea = num => {
        if (isNaN(num)) {
            num = '';
        }
        if (!/^\d*\.{0,1}\d{0,1}$/.test(num)) {
            num = num.replace(/\.\d{2,}$/, num.substr(num.indexOf('.'), 3));
        }
        if (num < 1) return '';
        return num;
    };

    const SELECE_LIMIT = (
        <>
            <Item
                label={intl.get('projectSpace.expireDate')}
                children={expireDate}
            />
            <Item label={intl.get('userCenter.paymentAmount')}>
                {gratisProjectNum < FREE_COUNT &&
                currentState.step === 'form' ? (
                    <>
                        <div className="payment-amount free-payment">
                            ￥{paymentAmount}
                            <div className="line"></div>
                        </div>
                        <span className="free-payment-discounts">
                            {intl.get('userCenter.freeLimited')}：
                            {`${+gratisProjectNum + 1}/${FREE_COUNT}`}
                        </span>
                    </>
                ) : (
                    <div className="payment-amount">￥{paymentAmount}</div>
                )}
            </Item>
        </>
    );

    const placeholders = ['province', 'city', 'county'];
    const houseTypeList = ['room', 'living', 'kitchen', 'rest'];
    const EMPTY_TEXT = [
        intl.get('projectSpace.selectProvince'),
        intl.get('projectSpace.selectCity'),
    ];
    const houseTypeEnum = [];
    for (let num = 0; num < 10; houseTypeEnum.push({ num: num++ }));

    const autoTarget = ({ target }) => {
        if (!target.getAttribute('data-emitter')) return;
        targetDetail();
    };

    const CONTENT = {
        //  创建、编辑项目
        form: (
            <>
                <Form
                    autoComplete="off"
                    form={formRef}
                    preserve={false}
                    labelCol={{ span: 6 }}
                    onFieldsChange={fieldsChangeHandler}
                    onFinish={onVerification}>
                    <Item
                        label={intl.get('projectSpace.creator')}
                        children={createName}
                    />

                    <Item
                        name="projectName"
                        rules={[
                            {
                                required: true,
                            },
                            {
                                type: 'string',
                                max: 30,
                            },
                        ]}
                        label={intl.get('userCenter.productName')}>
                        <Input
                            maxLength={30}
                            disabled={type === 2 && role !== 8}
                        />
                    </Item>
                    <Item
                        className="estate-name"
                        required
                        label={intl.get('projectSpace.estateName')}>
                        <Row gutter={[4, 4]}>
                            {placeholders.map((el, i) => (
                                <Col span={8} key={i}>
                                    <Select
                                        key={i}
                                        showSearch
                                        getPopupContainer={triggerNode =>
                                            triggerNode.parentNode
                                        }
                                        suffixIcon={suffixIcon}
                                        loading={selectLoading[i]}
                                        value={areaSelected[i]}
                                        placeholder={intl.get(
                                            `projectSpace.${el}`
                                        )}
                                        disabled={!regionOptions[i].length}
                                        notFoundContent={EMPTY_TEXT[i - 1]}
                                        dropdownMatchSelectWidth={150}
                                        filterOption={(input, option) =>
                                            PinyinMatch.match(
                                                option.children,
                                                input
                                            )
                                        }
                                        onSelect={e => setRegion(e, i, true)}>
                                        {regionOptions[i].map(e => (
                                            <Option key={e.id} value={e.code}>
                                                {e.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Col>
                            ))}
                            <Col span={24}>
                                <Item
                                    name="districtId"
                                    validateFirst
                                    rules={[
                                        {
                                            required: true,
                                            message: intl.get('nameEmptyWarn'),
                                        },
                                        {
                                            validator: async (rule, value) => {
                                                if (!value) return;
                                                const val = value.replace(
                                                    /[\u4e00-\u9fa5]/g,
                                                    'aa'
                                                );
                                                if (val.length < 61) {
                                                    return Promise.resolve();
                                                }
                                                throw new Error(
                                                    intl.get(
                                                        'projectSpace.nameMaxWarn'
                                                    )
                                                );
                                            },
                                        },
                                        {
                                            validator: async () => {
                                                if (
                                                    !areaSelected[1] ||
                                                    (!!regionOptions[2]
                                                        .length &&
                                                        !areaSelected[2])
                                                ) {
                                                    throw new Error(
                                                        intl.get(
                                                            'projectSpace.selectCounty'
                                                        )
                                                    );
                                                }
                                            },
                                        },
                                    ]}
                                    normalize={delSquareBrackets}
                                    noStyle>
                                    <AutoComplete
                                        filterOption={filterOption}
                                        onSelect={onSelect}
                                        onSearch={onSearch}
                                        onBlur={onBlur}
                                        options={estateList}
                                        dropdownClassName="dropdown-select">
                                        <Input.Search
                                            placeholder={intl.get(
                                                'projectSpace.nameMaxWarn'
                                            )}
                                            allowClear
                                            loading={estateLoading}
                                            onSearch={getEstate}
                                        />
                                    </AutoComplete>
                                </Item>
                            </Col>
                        </Row>
                    </Item>

                    {type === 2 ? (
                        <>
                            <Item label={intl.get('houseType.houseType')}>
                                <Form.List name="houseType">
                                    {() => (
                                        <Row gutter={5}>
                                            {houseTypeList.map((e, i) => (
                                                <Col span={6} key={i}>
                                                    <Item noStyle name={i}>
                                                        <Select
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            suffixIcon={
                                                                suffixIcon
                                                            }>
                                                            {houseTypeEnum.map(
                                                                el => (
                                                                    <Select.Option
                                                                        value={
                                                                            el.num
                                                                        }
                                                                        key={
                                                                            el.num
                                                                        }>
                                                                        {el.num +
                                                                            intl.get(
                                                                                `projectSpace.${e}`
                                                                            )}
                                                                    </Select.Option>
                                                                )
                                                            )}
                                                        </Select>
                                                    </Item>
                                                </Col>
                                            ))}
                                        </Row>
                                    )}
                                </Form.List>
                            </Item>

                            <Item
                                name="area"
                                normalize={parseArea}
                                label={intl.get('houseType.insideArea')}>
                                <Input
                                    style={{ width: '100%' }}
                                    suffix="㎡"
                                    className="unit-input"
                                />
                            </Item>

                            <Item
                                name="genre"
                                label={intl.get('userCenter.genre')}>
                                <Select
                                    getPopupContainer={triggerNode =>
                                        triggerNode.parentNode
                                    }
                                    style={{ width: '100%' }}
                                    suffixIcon={suffixIcon}>
                                    {genreList.map((e, i) => (
                                        <Select.Option value={e} key={i}>
                                            {e}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Item>

                            <Item
                                name="design"
                                rules={[
                                    {
                                        required: false,
                                    },
                                    {
                                        type: 'string',
                                        max: 30,
                                    },
                                ]}
                                label={intl.get('decorationDesign.designer')}>
                                <Input
                                    placeholder={intl.get(
                                        'projectSpace.enterDesigner'
                                    )}
                                    maxLength={30}
                                    style={{ width: '100%' }}
                                />
                            </Item>
                        </>
                    ) : (
                        <>
                            <Item
                                name="period"
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}
                                normalize={parseNumber}
                                initialValue={
                                    +gratisProjectNum < FREE_COUNT ? 6 : 1
                                }
                                label={intl.get('projectSpace.projectPeriod')}>
                                <Input
                                    style={{ width: '100%' }}
                                    addonAfter={intl.get('base.mon')}
                                    disabled={+gratisProjectNum < FREE_COUNT}
                                    className="unit-input"
                                />
                            </Item>
                            {SELECE_LIMIT}
                        </>
                    )}

                    <Item
                        name="note"
                        label={intl.get('projectSpace.projectRemark')}>
                        <Input.TextArea autoSize={{ minRows: 2 }} />
                    </Item>
                </Form>
                <div className="btns-wrap">
                    <Button
                        onClick={closeModal}
                        children={intl.get('base.cancel')}
                    />
                    <Button
                        type="primary"
                        loading={loading.form}
                        disabled={watchField?.some(e => !e)}
                        onClick={() => {
                            formRef.submit();
                        }}
                        children={intl.get('base.confirm')}
                    />
                </div>
            </>
        ),
        //  待支付
        unpaid: (
            <Form
                autoComplete="off"
                labelCol={{ span: 6 }}
                preserve={false}
                onFieldsChange={fieldsChangeHandler}>
                <Item label={intl.get('projectSpace.creator')}>
                    {appStore.userInfo.username}
                </Item>
                <Item
                    rules={[
                        {
                            required: true,
                            max: 30,
                        },
                    ]}
                    label={intl.get('userCenter.productName')}>
                    {initData.name}
                </Item>
                <Item label={intl.get('projectSpace.estateName')}>
                    {initData.districtName}
                </Item>
                <Item
                    normalize={parseNumber}
                    initialValue={1}
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                    label={intl.get('projectSpace.projectPeriod')}>
                    <Input
                        style={{ width: '100%' }}
                        value={period}
                        onChange={e =>
                            periodChange(parseNumber(e.target.value))
                        }
                        addonAfter={intl.get('base.mon')}
                        className="unit-input"
                    />
                </Item>
                {SELECE_LIMIT}
                <Item wrapperCol={{ offset: 6 }}>
                    <Button
                        type="primary"
                        disabled={period < 1}
                        onClick={toPay}>
                        {intl.get('projectSpace.toPay')}
                    </Button>
                </Item>
            </Form>
        ),
        // 扫码支付
        pay: (
            <div className="pay-wrap">
                <div className="QR-code">
                    <Spin
                        spinning={loading.code}
                        indicator={
                            <LoadingOutlined style={{ fontSize: 24 }} spin />
                        }>
                        <Image
                            preview={false}
                            className="qrcode-image"
                            onClick={refreshCode}
                            src={payData.payUrl}></Image>
                    </Spin>
                    <div className="amount-money">
                        ￥{payData.amount ?? '-'}
                    </div>
                    <div className="scan-tips">
                        {intl.get('userCenter.useWechartPay')}
                    </div>
                </div>
            </div>
        ),
        // 支付成功
        paid: (
            <div className="pay-wrap">
                <div className="detail-success-hint">
                    <i className="filled icon-Confirm success-icon"></i>
                    <div className="success-msg">
                        {intl.get('userCenter.paySuccess')}
                    </div>
                    <div className="target-msg" onClick={autoTarget}>
                        {intl.get('projectSpace.close')}
                        {intl.get('projectSpace.or')}
                        {intl.get('projectSpace.countDown', { timeCount })}
                        <a className="native-link" data-emitter="detail">
                            {intl.get('projectSpace.targetDetail')}
                        </a>
                    </div>
                </div>
            </div>
        ),
    };
    return (
        visible && (
            <BaseModal
                className="buy-service1_4 base-custom-modal"
                visible={visible}
                width="28.4375rem"
                title={currentState.title}
                footer={null}
                forceRender={true}
                destroyOnClose
                onCancel={closeModal}>
                {CONTENT[currentState.step]}
            </BaseModal>
        )
    );
}

export default inject('appStore', 'houseType')(observer(BuyService));
